module.exports = __webpack_public_path__ + "static/media/image4.64af754b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image4.jpg
// module id = 38
// module chunks = 0